import { render, staticRenderFns } from "./sb-base-info.vue?vue&type=template&id=d4fbddf6&scoped=true&"
import script from "./sb-base-info.vue?vue&type=script&lang=js&"
export * from "./sb-base-info.vue?vue&type=script&lang=js&"
import style0 from "./sb-base-info.vue?vue&type=style&index=0&id=d4fbddf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fbddf6",
  null
  
)

export default component.exports